import {CloseButton} from 'shells/button/close-button/close-button';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './thread-list-sidebar-header.module.css';

interface Props {
    title: string;
    subtitle: string;
    onClose: () => void;
}

export function ThreadListSidebarHeader(props: Props) {
    return (
        <div className={styles['thread-list-sidebar-header']}>
            <Stack spacing={4}>
                <Stack isHorizontal justifyContent='space-between'>
                    <Body size='large' isBold color='dark'>
                        {props.title}
                    </Body>
                    <CloseButton onClick={props.onClose} size={16} variant='dark' />
                </Stack>
                <Body size='small' color='light'>
                    {props.subtitle}
                </Body>
            </Stack>
        </div>
    );
}
